<div [innerHTML]="licenseContent"></div>
